import { JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from 'json2typescript';

import { JsonUtil } from '../../service/util/json.util';
import { AbstractEntity } from '../abstract-entity/abstract-entity';
import { Field } from './field';
import { FieldType } from './field-type.enum';

@JsonConverter
export class FieldsConverter implements JsonCustomConvert<Field[]> {
  serialize(fields: Field[]): any {
    fields.forEach(field => {
      if (field.type === FieldType.RADIO || field.type === FieldType.MULTI) {
        field.theName = `${field.fieldName}::${Array.from(field.options).map(option => option.value).join('|||')}`;
      } else {
        field.theName = field.fieldName;
      }
    });
    return fields;
  }

  deserialize(fields: any): Field[] {
    return JsonUtil.jsonConvert(fields, Field);
  }
}

@JsonObject
export class Archive extends AbstractEntity {
  @JsonProperty('name', String)
  name: string = undefined;

  @JsonProperty('tenantId', Number)
  tenantId: number = undefined;

  @JsonProperty('enabled', Boolean)
  enabled = true;

  @JsonProperty('fields', FieldsConverter)
  fields: Field[] = [];

  @JsonProperty('canUserSelfAdd', Boolean)
  canUserSelfAdd = true;

  @JsonProperty('canUserSelfQuery', Boolean)
  canUserSelfQuery = true;

  constructor() {
    super();
    this.name = '';
    this.tenantId = 0;
  }

  /**
   * æ·»å å­æ®µ
   */
  public addField(): Archive {
    let field = new Field();
    field.required = true;
    field.idx = this.getMaxIdx() + 1;
    this.fields.push(field);
    return this;
  }

  /**
   * å é¤å­æ®µ
   */
  public deleteField(field: Field) {
    this.fields = this.fields.filter(item => item.idx !== field.idx);
  }

  /**
   * å¤æ­archiveå¯¹è±¡æ¯å¦ä¸ºç©º
   */
  public isEmpty(): boolean {
    let count = 0;
    this.fields.forEach(field => {
      if (field.isEmpty()) {
        count++;
      }
    });
    return !this.name && (count === this.fields.length);
  }

  /**
   * å¤æ­archiveåå«æçå­æ®µæ¯å¦æç©ºé¡¹
   */
  public hasEmpty(): boolean {
    return !this.name;
  }

  /**
   * è·åç¬¬ä¸ä¸ªå­æ®µä¸ºç©ºçå­æ®µ
   */
  public getEmptyField(): Field {
    let fields = this.fields.filter(field => field.isEmpty());
    return fields.length ? fields[0] : undefined;
  }

  /**
   * è·åå­æ®µåè¡¨æéå¤ç
   * @returns Field[]
   */
  public getRepeatFields(): Field[] {
    let map: Map<string, Field[]> = new Map();
    this.fields.forEach(field => {
      if (map.has(field.fieldName)) {
        map.get(field.fieldName).push(field);
      } else {
        map.set(field.fieldName, [field]);
      }
    });
    let fields = Array.from(map.values()).filter(item => item.length > 1);
    return fields.length ? fields[0] : [];
  }

  /**
   * éè¿idæ¥è¯¢å­æ®µ
   * @param id
   */
  public getFieldByFieldId(id: number): Field {
    return this.fields.find(f => f.id === id);
  }

  /**
   * æ¯å¦å­å¨å¾çç±»åçå­æ®µ
   */
  public isExitImageField(): boolean {
    return this.fields.filter(field => field.type === FieldType.ATTACHMENT).length > 0;
  }

  /**
   * å°å­æ®µä¸ç§»
   */
  public moveUp(field: Field, isTop: boolean): void {
    if (isTop) {
      return;
    }
    for (let i = 0; i < this.fields.length; i++) {
      let item: Field = this.fields[i];
      if (item.idx === field.idx) {
        let idx = item.idx;
        item.idx = this.fields[i - 1].idx;
        this.fields[i - 1].idx = idx;
        break;
      }
    }
    this.reSortFields();
  }

  /**
   * å°å­æ®µä¸ç§»
   */
  public moveDown(field: Field, isEnd: boolean) {
    if (isEnd) {
      return;
    }
    for (let i = 0; i < this.fields.length; i++) {
      let item: Field = this.fields[i];
      if (item.idx === field.idx) {
        let idx = item.idx;
        item.idx = this.fields[i + 1].idx;
        this.fields[i + 1].idx = idx;
        break;
      }
    }
    this.reSortFields();
  }

  /**
   * éæ°ç»å­æ®µåè¡¨æåº
   */
  public reSortFields() {
    this.fields.sort((a, b) => {
      return a.idx - b.idx;
    });
  }

  private getMaxIdx(): number {
    let max = 0;
    this.fields.forEach(field => {
      if (field.idx > max) {
        max = field.idx;
      }
    });
    return max;
  }
}
